import React from 'react';

const Footer = () => {
    return (
        <footer className="footer footer-center p-4 text-base-content mt-10 text-[20px] text-gray-500 font-serif">
            <aside>
                <p>Thanks for visiting my portfolio</p>
                <p>Copyright © 2023 <span className='font-sans' >Sujon Hasan</span> </p>
            </aside>
        </footer>
    );
};

export default Footer;